import React from 'react';
import { func, node, oneOf, bool } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { IconSpinner, StripeConnectAccountStatusBox } from '../../components';

import css from './TransactionPanel.css';

// The freelancer's offer form, behind a check that their Stripe account can
// take the customer's card payment: a spinner while it is checked, the
// dashboard's "Stripe needs more information" box when it can't, the form
// when it can.
const CustomOfferStripeGate = props => {
  const { status, onGetStripeConnectAccountLink, linkInProgress, children } = props;

  if (status === 'checking') {
    return (
      <div className={css.offerStripeGateChecking}>
        <IconSpinner />
      </div>
    );
  }
  if (status === 'blocked') {
    return (
      <div className={css.offerStripeGate}>
        <p className={css.offerStripeGateIntro}>
          <FormattedMessage id="CustomOfferStripeGate.intro" />
        </p>
        <StripeConnectAccountStatusBox
          type="verificationNeeded"
          inProgress={linkInProgress}
          onGetStripeConnectAccountLink={onGetStripeConnectAccountLink}
        />
      </div>
    );
  }
  return children;
};

CustomOfferStripeGate.defaultProps = { linkInProgress: false };

CustomOfferStripeGate.propTypes = {
  status: oneOf(['checking', 'blocked', 'open']).isRequired,
  onGetStripeConnectAccountLink: func.isRequired,
  linkInProgress: bool,
  children: node.isRequired,
};

export default CustomOfferStripeGate;
